import http from "./Endpoint";
import { appConstant } from "config/constant";

class AddressService {

  addressValidate(data) {
    return http().post("/address/addressValidate", data);
  }

  /**
   * Get address list in the dropdown
   * @param {*} data {
   *   "filter": {
   *     "user_id": user.id,
   *     "customer_id": user.customer_id,
   *     "is_active": 1
   *   }
   * }
   * @returns [
   *  { "key": "", "html": ""}
   * ]
   */
  list(data) {
    return http().post("/address/list", data);
  }

  /**
   * Get address list in the dropdown
   * @param {*} data {
   *   "filter": {
   *     "user_id": user.id,
   *     "customer_id": user.customer_id,
   *     "is_active": 1,
   *     "department_id": 1
   *   }
   * }
   * @returns [
   *  
   * ]
   */
  query(data) {
    return http().post("/address/query", data);
  }

  /**
   * @param {*} data - [
   *  "zipcode" => 92801
   * ]
   * @returns 
   */
  getSalesTaxRate(data) {
    return http().post("/address/getSalesTaxRate", data);
  }

}

export default new AddressService();